/** Fixed rounded control appearance used by the native member-style apps. */
export const roundedControlThemeTokens = { borderRadius: 8 } as const;
